import {OrderIntakeOptionsDto} from '@hconnect/tuc-processes/orderIntake'

/**
 * Normalizes RMC options to ensure all array fields are actual arrays.
 * Backend sometimes returns non-array values when data is missing.
 *
 * @param options The raw RMC options from the API
 * @returns Normalized options with guaranteed array fields
 */
export const normalizeRmcOptions = (
  options: OrderIntakeOptionsDto | undefined
): OrderIntakeOptionsDto | undefined => {
  if (!options) {
    return undefined
  }

  return {
    ...options,
    contracts: Array.isArray(options.contracts) ? options.contracts : [],
    plants: Array.isArray(options.plants) ? options.plants : [],
    sites: Array.isArray(options.sites) ? options.sites : [],
    configurations: Array.isArray(options.configurations) ? options.configurations : []
  }
}
